/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/** Address object, used in the Site object */
export interface Address {
  /** Street name */
  street: string;
  /** City */
  city: string;
  /** State */
  state: string;
  /** Postal Code */
  postalCode: string;
  /** Country */
  country: string;
  /** GPS Coordinates object, used in the Address object */
  gpsCoordinates: GPSCoordinates;
}

/** The answer to a question in a questionnaire */
export interface AnswerPayload {
  /** The type of the answer */
  $type: string;
}

/** Audit information */
export interface AuditInformation {
  /** Information about who or what created or modified an item */
  created?: AuditRecord;
  /** Information about who or what created or modified an item */
  lastModified?: AuditRecord;
}

/** Information about who or what created or modified an item */
export interface AuditRecord {
  /** The user or principal */
  userUri: string | null;
  /**
   * When the operation was recorded
   * @format date-time
   */
  timeStamp: string;
  /**
   * The traceId for the operation which
   * created this audit record
   */
  traceId: string;
}

/** Request to book a time slot for patient */
export interface BookSlotRequest {
  /** Patient Id */
  patientId?: string;
}

/** A bookable slot */
export interface BookableSlot {
  /**
   * The slot id
   * @example "6B962824-0B9D-4097-9411-5530331C1BB9"
   */
  slotId: string;
  /**
   * The site id
   * @example "2CDE45B7-CC15-44CC-9967-F5C2BAE3B287"
   */
  siteId: string;
  /**
   * The site name
   * @example "Östermalmstorg"
   */
  siteName: string;
  /**
   * The start time in local time
   * @format date-time
   * @example "2024-03-15T13:00:00"
   */
  startTime: string;
  /**
   * The end time in local time
   * @format date-time
   * @example "2024-03-15T14:00:00"
   */
  endTime: string;
  /**
   * The ETag
   * @example "27236F5696CB"
   */
  eTag: string;
}

/** Envelope for paginated responses */
export interface BookableSlotPaginatedResponse {
  /** Continuation token to fetch the next page if it exists. */
  nextPage: string | null;
  /** The items in this response. */
  items: BookableSlot[];
}

/** Booking Token - allows booking slots */
export interface BookingTokenV2 {
  /**
   * Id of the booking token
   * @format uuid
   */
  bookingTokenId: string;
  /** Id of the Patient owner of the token */
  patientId: string;
  /**
   * Id of the slot the token is redeemed to book
   * @format uuid
   */
  slotId?: string | null;
  /** Is the token available for booking */
  availableForBooking: boolean;
  /** ETag - version of the token's state */
  eTag: string;
  /**
   * Order Id associated with the token
   * @format uuid
   */
  orderId?: string | null;
  /**
   * Booking Abandonment Notification Id
   * @format uuid
   */
  bookingAbandonmentNotificationId?: string | null;
}

/** Envelope for paginated responses */
export interface BookingTokenV2PaginatedResponse {
  /** Continuation token to fetch the next page if it exists. */
  nextPage: string | null;
  /** The items in this response. */
  items: BookingTokenV2[];
}

/** Boolean answer */
export type BooleanAnswerPayload = AnswerPayload & {
  $type?: string;
  /** The value of the answer */
  value?: boolean;
};

/** Request to create a new booking slot v2. */
export interface CreateSlotV2Request {
  /**
   * Start time of the slot.
   * @format date-time
   */
  startTime: string;
  /**
   * End time of the slot.
   * @format date-time
   */
  endTime: string;
  /** Room that this slot belongs to */
  roomId: string;
  /** Visit type of this slot */
  visitTypeId?: string | null;
  /** Whether this slot should show up in PatientApp */
  isOpenPublicly: boolean;
}

/** Enum answer */
export type EnumAnswerPayload = AnswerPayload & {
  $type?: string;
  /**
   * The value of the answer
   * @format int32
   */
  value?: number;
  /** The label of the answer */
  label?: string;
};

/** GPS Coordinates object, used in the Address object */
export interface GPSCoordinates {
  /**
   * Latitude
   * @format double
   */
  latitude: number;
  /**
   * Longitude
   * @format double
   */
  longitude: number;
}

/** Text answer */
export type NumberAnswerPayload = AnswerPayload & {
  $type?: string;
  /**
   * The value of the answer
   * @format double
   */
  value?: number;
};

/** A question and answer which is part of a Questionnaire */
export interface QuestionAnswer {
  /**
   * The ID for the question to identify the question in the questionnaire
   * without knowing the question label text.
   *
   * Only unique in a questionnaire.
   */
  questionId?: string;
  /** Questionnaire language codes (ISO 639-1) */
  languageCode?: QuestionnaireLanguageCode;
  /**
   * The text of the question as presented to the user, this
   * question should be in the language specified in `LanguageCode`
   */
  label?: string;
  /** The text of the question, but the untranslated english version. */
  englishLabel?: string | null;
  /** The answer to the question. */
  answer?:
    | TextAnswerPayload
    | NumberAnswerPayload
    | TextArrayAnswerPayload
    | BooleanAnswerPayload
    | EnumAnswerPayload
    | null;
}

/** Questionnaire language codes (ISO 639-1) */
export enum QuestionnaireLanguageCode {
  En = "en",
  Sv = "sv",
}

/** A response to a questionnaire */
export interface QuestionnaireResponse {
  /** The type of the questionnaire */
  questionnaireType?: string;
  /** The patient who owns this response */
  patientId?: string;
  /**
   * The ID of this response
   * @format uuid
   */
  responseId?: string;
  /** The questions and answers */
  questionsAndAnswers?: QuestionAnswer[];
  /** The state of a questionnaire response */
  state?: QuestionnaireResponseState;
  /**
   * VisitId
   * @format uuid
   */
  visitId?: string | null;
  /**
   * Timestamp for creation
   * @format date-time
   */
  responseCreatedAt?: string | null;
  /**
   * Timestamp for completion
   * @format date-time
   */
  responseCompletedAt?: string | null;
  /** Audit information */
  audit?: AuditInformation;
}

/** Envelope for paginated responses */
export interface QuestionnaireResponsePaginatedResponse {
  /** Continuation token to fetch the next page if it exists. */
  nextPage: string | null;
  /** The items in this response. */
  items: QuestionnaireResponse[];
}

/** The state of a questionnaire response */
export enum QuestionnaireResponseState {
  Incomplete = "incomplete",
  Complete = "complete",
}

/** Room in a clinic. Contains Site information, and supported visit types */
export interface Room {
  /** Id of the room */
  id: string;
  /** Display name of the room */
  displayName: string | null;
  /**
   * Id of the patient group of the clinic in which the room is present
   * @format uuid
   */
  patientGroupId: string | null;
  /** Site of the room, namely Clinic/Location */
  site?: Site;
  /** Types of visits that rooms supports. ie Scan, blood pressure checks, maintenance etc */
  supportedVisitTypes?: VisitType[] | null;
}

/** Represents a room with SlotsV2 */
export interface RoomWithSlotsV2 {
  /** Id of the room */
  roomId: string;
  /** Display name of the room */
  displayName: string | null;
  /**
   * Id of the patient group of the clinic in which the room is present
   * @format uuid
   */
  patientGroupId: string | null;
  /** Site of the room, namely Clinic/Location */
  site: Site;
  /** Slots of the room */
  slots?: ScheduleViewSlotV2[];
}

/** Envelope for paginated responses */
export interface RoomWithSlotsV2PaginatedResponse {
  /** Continuation token to fetch the next page if it exists. */
  nextPage: string | null;
  /** The items in this response. */
  items: RoomWithSlotsV2[];
}

/** Represents the details of a patient for a scheduled view slot. */
export interface ScheduleViewSlotPatientDetailsV2 {
  /** The patient ID to whom the slot is booked. */
  patientId: string;
  /** The display name of the patient to whom the slot is booked. */
  displayName: string | null;
  /** Whether the patient has finished onboarding questionnaire. */
  finishedOnboarding: boolean;
}

/** Slot with patient information to show in the schedule view in Doctor UI */
export interface ScheduleViewSlotV2 {
  /** The ID of the Site. */
  siteId: string;
  /** The ID of the Slot. It's a composite key consisting of {SiteId}_{SlotId} */
  slotId: string;
  /**
   * Start time of the slot in local time.
   * @format date-time
   */
  startTime: string;
  /**
   * End time of the slot in local time
   * @format date-time
   */
  endTime: string;
  /** Represents the details of a patient for a scheduled view slot. */
  patientDetails: ScheduleViewSlotPatientDetailsV2;
  /** Whether this slot is free to be booked. */
  isFree: boolean;
  /** Whether the patient has been checked in. */
  checkedIn: boolean;
  /** Whether this slot can be seen by PatientApp */
  isOpenPublicly: boolean;
  /** Whether this slot is booked. */
  isBooked: boolean;
  /** Room Id where the slot will take place */
  roomId: string;
  /** ETag */
  eTag: string;
}

/** Site of the room, namely Clinic/Location */
export interface Site {
  /** Id of the site */
  siteId: string;
  /** Site name */
  siteName: string;
  /** Address object, used in the Site object */
  address: Address;
  /** String representing the TimeZoneId */
  timeZoneId: string;
}

/** Envelope for paginated responses */
export interface SitePaginatedResponse {
  /** Continuation token to fetch the next page if it exists. */
  nextPage: string | null;
  /** The items in this response. */
  items: Site[];
}

/** A booking SlotV2 */
export interface SlotV2 {
  /**
   * The ID of the Slot.
   * Composite key consisting of SiteId and SlotId
   */
  slotId: string;
  /** Room in a clinic. Contains Site information, and supported visit types */
  room: Room;
  /**
   * Start time of the slot with offset.
   * The timezone of the datetime will be in the timezone of the site
   * @format date-time
   */
  startTime: string;
  /**
   * End time of the slot with offset.
   * The timezone of the datetime will be in the timezone of the site
   * @format date-time
   */
  endTime: string;
  /** The patient ID to whom the slot is booked. */
  patientId: string | null;
  /**
   * The booking token ID to which the slot is booked.
   * @format uuid
   */
  bookingTokenId: string | null;
  /**
   * Whether this slot can be shown in PatientApp or not.
   * A slot that is not open publicly cannot be booked by a member, but can be booked in DoctorUI if there's no patientId set
   * A slot that is open publicly and doens't have a patientId set can be booked in PatientApp or DoctorUI
   * Calculated from PatientId and IsOpenPublicly.
   */
  isOpenPublicly: boolean;
  /**
   * Whether this slot is free to be booked or not.
   * Calculated from PatientId and IsOpenPublicly.
   * IsBooked and IsOpenPublicly are false when true
   */
  isFree: boolean;
  /** The id of the visit type that this slot allows, default = "Scan" */
  visitTypeId: string;
  /** ETag */
  eTag: string;
}

/** Enumeration to describe sort order */
export enum SortOrder {
  Asc = "asc",
  Desc = "desc",
}

/** Text answer */
export type TextAnswerPayload = AnswerPayload & {
  $type?: string;
  /** The text value of the answer */
  value?: string;
};

/** Text array answer */
export type TextArrayAnswerPayload = AnswerPayload & {
  $type?: string;
  /** The value of the answer */
  value?: string[];
};

/** Request to unbook a slot */
export interface UnBookSlotRequest {
  /** Should refund token */
  refundToken?: boolean;
}

/** A type of a visit, ie scan, blood pressue check, maintenance etc. */
export interface VisitType {
  visitTypeId: string;
  /** @format int32 */
  defaultLengthMinutes: number;
}

export interface BookingV2QueryBookableSlotsParams {
  siteIds?: string[];
  /**
   * Inclusive
   * @format date-time
   */
  "startTimeRange.start"?: string;
  /**
   * Exclusive
   * @format date-time
   */
  "startTimeRange.end"?: string;
  /** The continuation token */
  continuationToken?: string;
  /**
   * The page size
   * @format int32
   */
  pageSize?: number;
}

export interface BookingTokenQueryPatientsParams {
  /** @default true */
  availableForBooking?: boolean;
  /** The continuation token */
  continuationToken?: string;
  /**
   * The page size
   * @format int32
   */
  pageSize?: number;
  /**
   * Owner patient
   * @format string
   */
  patientId: string;
}

export interface QuestionnaireQueryPatientResponsesParams {
  /**
   * Inclusive
   * @format date-time
   */
  "createdAtRange.start"?: string;
  /**
   * Exclusive
   * @format date-time
   */
  "createdAtRange.end"?: string;
  /** Questionnaire responses are sorted by creation timestamp */
  order?: SortOrder;
  /**
   * Filter by VisitId
   * @format uuid
   */
  visitId?: string;
  /** Filter responses by questionnaire type */
  questionnaireType?: string;
  /** The continuation token */
  continuationToken?: string;
  /**
   * The page size
   * @format int32
   */
  pageSize?: number;
  /**
   * The ID of the patient
   * @format string
   */
  patientId: string;
}

export interface SlotV2GetSiteScheduleViewParams {
  /**
   * Inclusive
   * @format date-time
   */
  start?: string;
  /**
   * Exclusive
   * @format date-time
   */
  end?: string;
  /** A continuation token */
  continuationToken?: string;
  /** SiteId for which to get schedule */
  siteId: string;
}
